import resources from './resources'

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: (JSON.parse(localStorage.getItem('configuration')) || {}).language || navigator.language.slice(0,2),
  resources,
}

export { resources }
